module.exports = __webpack_public_path__ + "img/FI22047862.d20c1a19.png";